import { forwardRef, useCallback } from 'react'
import { Image } from 'react-bootstrap'

import { getPlaceholderImage } from 'Utilities'

import { ImageWithFallbackProps } from './ImageWithFallback.types'

export const ImageWithFallback = forwardRef(
  (
    props: ImageWithFallbackProps,
    ref: React.ForwardedRef<HTMLImageElement>,
  ) => {
    const { placeholderType, src, ...rest } = props
    const placeholderImage = getPlaceholderImage(placeholderType)
    const imageSource = src || placeholderImage

    const handleImageError = useCallback(
      (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
        event.currentTarget.onerror = null
        event.currentTarget.src = placeholderImage
      },
      [placeholderImage],
    )

    return (
      <Image ref={ref} src={imageSource} {...rest} onError={handleImageError} />
    )
  },
)
